import {
  Box,
  Button,
  Grid,
  IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MoreVert } from '@material-ui/icons';
import { useBaseStore } from '@roc/feature-app-core';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useLoanStore } from '@roc/feature-loans-shared';
import { formatDate } from '@roc/feature-utils';
import {
  AgGridColumnProps,
  DataGrid as ExtensionGrid,
  LinkColumn,
  Paper, StandardDialog
} from '@roc/ui';
import { formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useExtensionRequestStore } from '../../../../../feature-loans/src/loans/loanDetails/modules/loanRequests/hooks/useExtensionRequestStore';
import { ExtensionKeyDatesNew } from './extensionKeyDates';
import ExtensionsWarnings from './extensionsWarnings';
import ExtensionRequestModal from './loanRequests/extensionRequestModal';


const noOpComparator = () => 0;

const columns: AgGridColumnProps[] = [
  {
    field: 'extensionNumber',
    headerName: 'Extension #',
    minWidth: 100,
    cellRenderer: 'extensionNumberCellRenderer',
    comparator: noOpComparator,
    sortable: false,
  },
  {
    field: 'requestDate',
    headerName: 'Requested Date',
    minWidth: 100,
    comparator: noOpComparator,
    sortable: false,
  },
  {
    field: 'extensionDuration',
    headerName: 'Extension Duration',
    minWidth: 100,
    cellRenderer: 'extensionDurationCellRenderer',
    comparator: noOpComparator,
    sortable: false,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 100,
    // cellRenderer: 'amountRenderer',
    comparator: noOpComparator,
    sortable: false,
  },

];

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
  },
  gridContainer: {
    paddingTop: 24,
  },

}));


export const ExtensionsDashboardSharedNew = observer(
  ({ loanId }: { loanId: string }) => {
    const { loanStore } = useLoanStore();
    const { loanRoutesConfig } = useLoanRoutes();
    const {
      extensionRequestStore,
      extensionRequestStore: { extensionList, currentExtension, disabledCreateExtesion },
    } = useExtensionRequestStore();
    const [openRequestExtensionModal, setopenRequestExtensionModal] = useState(
      false
    );
    const { globalStore } = useBaseStore();
    const closeModal = () => {
      setopenRequestExtensionModal(false);
    }
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
    const classes = useStyles();
    const menuOpen = Boolean(anchorEl);
    const [extensionId, setExtensionId] = useState(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    useEffect(() => {
      extensionRequestStore.setSaved(false);
      extensionRequestStore.fetchExtensionsByLoanId(loanId);
    }, []);
    const frameworkComponents = {
      dateCellRenderer: ({ value }) => {
        return value ? formatDate(value) : '';
      },
      extensionNumberCellRenderer: params => {
        const extensionId = params.node.data?.extensionId;
        const { onClick } = params;
        const value = `Extension ${params.value}`;
        return LinkColumn({
          value,
          onClick,
          url: loanRoutesConfig
            .loans(loanId)
            .children.extensionDetails(params.node.data?.loanExtensionId).url,
        });
      },
      amountRenderer: ({ value }) => {
        return value ? formatCurrency(value) : '';
      },
      actionsCellRenderer: params => {

        return (
          <IconButton onClick={e => openMenu(e, params.node.data.extensionId)}>
            <MoreVert color="primary" />
          </IconButton>
        );
      },
      extensionDurationCellRenderer: ({ value }) => {
        if (value == null) return '';
        return value === -1 ? 'Custom' : `${value} months`;
      },
    };
    const openMenu = (event: React.MouseEvent<HTMLElement>, record) => {
      setExtensionId(record);
      setAnchorEl(event.currentTarget);
    };

    return (
      <>
        <Grid item container direction="row" spacing={3} xs={12} style={{
          margin: 0
        }}>
          <ExtensionKeyDatesNew />
          {extensionRequestStore.checkWarningsForDashboard(loanStore.loanDetails.calculatedLoanData.nextDueDate, loanStore.loanDetails.extendedMaturityDate) === true &&
            <ExtensionsWarnings isFullWidth={true} />
          }
        </Grid>
        <Grid item xs={12} className={classes.gridContainer}>
          <Paper style={{
            paddingBottom: 16
          }}>
            <Grid container>
              <Grid item xs={12}>
                <Grid container justifyContent="space-between">
                  <Grid item></Grid>
                  {!globalStore.userFeatures.isInsuranceReviewer &&
                    <Grid item>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          disabled={disabledCreateExtesion}
                          onClick={() =>
                            setopenRequestExtensionModal(true)
                          }
                        >
                          Request Extension
                        </Button>
                      </Box>
                    </Grid>
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <ExtensionGrid
                  columns={columns}
                  rows={extensionList}
                  frameworkComponents={frameworkComponents}
                  domLayout="autoHeight"
                />
              </Grid>
              <StandardDialog
                open={openRequestExtensionModal}
                title=""
                maxWidth="md"
                handleClose={() => setopenRequestExtensionModal(false)}
                dialogContent={
                  <ExtensionRequestModal closeModal={() => closeModal()} />
                }
              />
            </Grid>
          </Paper>
        </Grid>
      </>
    );
  }
);
